// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/styling-" + {"13921":"f690e0ddcd6bf4e46c54","63598":"5097533d921f1eea007d"}[chunkId] + ".css";
};